import { ViajeEspecial } from "../viajeEspecial.dto";
import { BaseResponseDTO } from "./base.response.dto";

export class GetListaViajesEspecialesResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: Array<ViajeEspecial>;
  }
  